module.exports = {
      id: "mobile-share-usage",
      viewBox: "0 0 16.211 17.807",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#mobile-share",
      toString: function () {
        return this.url;
      }
    }